export const riyadaApi = 'customer-account/customer/'
export const salesLeadApi = `product-orchestration/sales-leads`
export const validateUserNameApi = `customer-account/adsl/users`
export const getBtlPlansApi = `product-service/product/offer`

